import { useEffect, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, ChevronLeft, ChevronRight } from "lucide-react";

export const Lightbox = ({ open, images, index, onClose, onNav }) => {
  const go = useCallback(
    (dir) => {
      if (!images.length) return;
      onNav((index + dir + images.length) % images.length);
    },
    [images, index, onNav]
  );

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowRight") go(1);
      if (e.key === "ArrowLeft") go(-1);
    };
    window.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, go, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          data-testid="lightbox"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={onClose}
          className="fixed inset-0 z-[120] bg-[#050A18]/95 backdrop-blur-sm flex items-center justify-center"
        >
          <button data-testid="lightbox-close" onClick={onClose}
            className="absolute top-5 right-5 text-white/70 hover:text-[#D4AF37] transition-colors z-10">
            <X size={30} />
          </button>

          <button data-testid="lightbox-prev" onClick={(e) => { e.stopPropagation(); go(-1); }}
            className="absolute left-3 md:left-8 text-white/70 hover:text-[#D4AF37] transition-colors z-10">
            <ChevronLeft size={44} />
          </button>
          <button data-testid="lightbox-next" onClick={(e) => { e.stopPropagation(); go(1); }}
            className="absolute right-3 md:right-8 text-white/70 hover:text-[#D4AF37] transition-colors z-10">
            <ChevronRight size={44} />
          </button>

          <AnimatePresence mode="wait">
            <motion.img
              key={index}
              src={images[index]}
              alt={`Photo ${index + 1}`}
              onClick={(e) => e.stopPropagation()}
              initial={{ opacity: 0, scale: 0.98 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.98 }}
              transition={{ duration: 0.3 }}
              className="max-w-[90vw] max-h-[82vh] object-contain shadow-2xl ring-1 ring-[#D4AF37]/30"
            />
          </AnimatePresence>

          <div className="absolute bottom-6 left-0 right-0 text-center text-white/60 text-sm tracking-widest">
            {index + 1} / {images.length}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
